
import { defineComponent, inject, onMounted, reactive, ref } from 'vue';
import { useRouter } from 'vue-router';
import { get } from 'lodash';
import { Message } from '@/appConfig';
import { getUserProjectList } from '@/services/home';
import HomeProject from '@/components/HomeProject.vue';
import { isCustom } from '@/components/customConditionList';
import { Modal } from 'ant-design-vue';

export default defineComponent({
  name: 'HomeList',
  components: {
    HomeProject
  },
  emits: ['set-loading'],
  setup(props, { emit }) {
    const router = useRouter();
    const message = inject('$message') as Message;
    const filter = reactive({
      status: 'ALL',
      name: ''
    });
    const list = ref([]);
    const loading = ref(false);
    const goCustom = (projectId: number) => {
      // console.log('跳转');
      router.push({ name: 'ProjectCustomNav', params: { projectId } });
    };

    function goProject(
      project: { id: number; projectStatus: string },
      userProjectRel: { roleId: number; userStatus: string }
    ) {
      if (
        userProjectRel.userStatus === 'FROZEN' ||
        project.projectStatus !== 'IN_PROGRESS'
      ) {
        console.log('冻结，非进行中');
        return;
      }
      if (userProjectRel.roleId === 0) {
        Modal.warning({
          title: '暂无当前项目权限',
          content: '请联系管理员配置权限',
          okText: '确定',
          centered: true,
          maskClosable: true,
          width: 438
        });
      } else {
        if (isCustom(project.id)) {
          goCustom(project.id);
        } else {
          location.href = `/keyan/?projectId=${project.id}`;
        }
      }
    }
    function getProjectList(isNeedJudgeCustom: boolean) {
      // emit('set-loading', {loading: true, isNeedJudgeCustom: isNeedJudgeCustom});
      const params = {
        projectName: filter.name === '' ? undefined : filter.name,
        projectStatus: filter.status === 'ALL' ? undefined : filter.status
      };
      getUserProjectList(params).then(res => {
        if (res.data && res.data.success) {
          list.value = res.data.data;
          // 如果只有一个项目判断状态然后河肿跳转定制导航
          if (res.data.data.length === 1 && isNeedJudgeCustom) {
            const date = res.data.data[0];
            const userStatus = date.userProjectRel.userStatus;
            const roleId = date.userProjectRel.roleId;
            const projectStatus = date.projectVo.project.projectStatus;
            const projectId: number = date.projectVo.project.id;
            if (userStatus === 'FROZEN' || projectStatus !== 'IN_PROGRESS') {
              return;
            } else if (roleId === 0) {
              Modal.warning({
                title: '暂无当前项目权限',
                content: '请联系管理员配置权限',
                okText: '确定',
                centered: true,
                maskClosable: true,
                width: 438
              });
            } else if (isCustom(projectId)) {
              goCustom(projectId);
            } else {
              const { projectVo, userProjectRel } = res.data.data[0];
              goProject(projectVo.project, userProjectRel);
            }
          }
        } else {
          const msg =
            res.data && res.data.msg ? res.data.msg : '获取项目列表失败！';
          message.error(msg);
        }
        // emit('set-loading', {loading: false, isNeedJudgeCustom: false});
      });
    }

    onMounted(() => {
      getProjectList(true);
    });

    return {
      filter,
      getProjectList,
      list,
      goCustom,
      loading
    };
  }
});
